<template>
  <div class="w-full flex gap-2">
    <button @click="() => {checkinAppointment()}"
            class="rounded-xl border border-input bg-white hover:bg-input text-green-600 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0"
            :class="{'!text-gray-400': appointment.checkinDate}">
      <Icon icon="cuida:checkbox-checked-outlined" width="24"
            height="24"/>
    </button>
    <button @click="() => {cancelAppointment()}"
            class="rounded-xl border border-input bg-white hover:bg-input text-red-500 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:cancel-rounded" width="24"
            height="24"/>
    </button>
    <button v-if="!appointment.inQueue" @click="() => {addAppointmentToQueue()}"
            class="rounded-xl border border-input bg-input hover:bg-input p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="ic:twotone-monitor" width="24" height="24"/>
    </button>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Icon} from '@iconify/vue';
import Appointment from "@/models/customer/Appointment";
import {formatPostgresDate} from "@/utils/date";

export default defineComponent({
  setup() {
    const appointment = ref<Appointment>(new Appointment())
    const appointmentsFilter = ref("");
    return {
      appointment,
      appointmentsFilter
    }
  },
  components: {
    Icon
  },
  mounted() {
    /* @ts-ignore */
    this.appointment = Appointment.from(this.params?.data)
    /* @ts-ignore */
    this.appointmentsFilter = this.params?.appointmentsFilter
  },
  watch: {
    appointmentsFilter: {
      handler(newValue) {
        this.appointmentsFilter = newValue
      },
    },
  },
  methods: {
    notify() {
      /* @ts-ignore */
      this.params.reload();
    },
    async checkinAppointment() {
      try {
        if (this.appointment.checkinDate) {
          this.appointment.status = 'un_checkin';
        } else {
          this.appointment.status = 'checkin';
        }
        this.appointment.requestOnlyAppointmentDate = formatPostgresDate(this.appointment.appointmentDate)
        this.appointment = await this.$http.put<Appointment>(Appointment.ENDPOINT + `/${this.appointment.id}/change-status`, this.appointment);
        this.notify();
      } catch (e) {
        console.log(e)
      }
    },
    cancelAppointment() {
      try {
        this.appointment.status = 'cancel';
        this.appointment.requestOnlyAppointmentDate = formatPostgresDate(this.appointment.appointmentDate)
        this.$http.put(Appointment.ENDPOINT + `/${this.appointment.id}/change-status`, this.appointment);
        this.notify();
      } catch (e) {
        console.log(e)
      }
    },
    addAppointmentToQueue() {
      try {
        this.$http.put(Appointment.ENDPOINT + `/${this.appointment.id}/add-to-queue`, this.appointment);
        this.notify();
      } catch (e) {
        console.log(e)
      }
    }
  }
})
</script>
